import { Icon } from "@iconify/react/dist/iconify.js";
import { Box } from "@mui/material";
import { useState, useEffect } from "react";
import { ResizableBox as RB } from "react-resizable";
const ResizableBox = ({ children, initialHeight = 600, maxHeight = 800 }) => {
  const [height, setHeight] = useState(initialHeight);

  useEffect(() => {
    setHeight(initialHeight);
  }, [initialHeight]);
  return (
    <RB
      width={Infinity}
      height={height}
      minConstraints={[100, 100]}
      maxConstraints={[Infinity, maxHeight]}
      resizeHandles={["se"]}
      handle={(resizeHandle, ref) => (
        <Box
          ref={ref}
          className="custom-resize-handle"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "20px",
            height: "20px",
            cursor: "se-resize",
          }}>
          <Icon icon="vaadin:handle-corner" style={{ color: "grey", fontSize: "20px" }} />
        </Box>
      )}
      onResizeStop={(_, data) => {
        setHeight(data.size.height);
      }}>
      {children}
    </RB>
  );
};
export default ResizableBox;
